import React from 'react';
import './SectionHeader.css';

/**
 * 섹션 머리말 — Eyebrow + Headline + Sub
 * align: 'left' | 'center'
 */
const SectionHeader = ({
  eyebrow,
  title,
  description,
  align = 'left',
  invert = false,
  className = '',
  children,
}) => {
  const cls = [
    'ft-section-header',
    `ft-section-header--${align}`,
    invert ? 'ft-section-header--invert' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={cls}>
      {eyebrow ? <span className="ft-section-header__eyebrow">{eyebrow}</span> : null}
      {title ? <h2 className="ft-section-header__title">{title}</h2> : null}
      {description ? <p className="ft-section-header__desc">{description}</p> : null}
      {children}
    </header>
  );
};

export default SectionHeader;
